import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Command from "../management/Command";
import Controller from "../management/Controller";
import PointOfSales from "../management/PointOfSales";
import Users from "../management/Users";
import DashboardComponent from "./DashboardComponent";
import { HomeComponent } from "./home/HomeComponent";
import PubliciteComponent from "./PubliciteComponent";




const ContentMenu = ({choosedMenu}) => {
  const dispatcher = useDispatch();
  const menuKey = choosedMenu.map(e => e.label).reduce((e, e1) => e + "," + e1);

  useEffect(() => {
    if (menuKey !== "Home" && menuKey !== "Home,Dashboard") {
      dispatcher({ type: "WIP_DISABLED" });
    }
  }, [menuKey, dispatcher]);

  switch (menuKey) {
    case "Home":
      return <HomeComponent />
    case "Home,Dashboard":
      return <DashboardComponent/>
    case "Home,Management,Controller":
      return <Controller />;
    case "Home,Management,PointOfSales":
      return <PointOfSales />;
    case "Home,Management,Users":
      return <Users />;
    case "Home,Management,Commands":
      return <Command />;
    case "Home,Advertisement,Resources":
      return <PubliciteComponent />;
  default:
  return (
    <div />
  );
  }
};

export default ContentMenu;
